import * as React from 'react';
import * as _ from 'lodash';
import CheckBox from '../components/PageLayout/CheckBox';
import { PARTS } from './../schemas/accessRightsModel';
export default function () {
    function onClick1(AR, styleClass, enabledClass, disabledBorderClass, KVLayerCountMax, e) {
        AR.e(PARTS.STONE_SETUP_ENABLE) && this.onToggleEnabled();
    }
    function onChange2(AR, styleClass, enabledClass, disabledBorderClass, KVLayerCountMax, e) {
        AR.e(PARTS.STONE_SETUP_EDIT_PRICE) && this.onChange('price', e.target.value);
    }
    function onBlur3(AR, styleClass, enabledClass, disabledBorderClass, KVLayerCountMax, e) {
        AR.e(PARTS.STONE_SETUP_EDIT_PRICE) && this.updatePriceTransientfield(e.target.value);
    }
    function onClick4(AR, styleClass, enabledClass, disabledBorderClass, KVLayerCountMax, e) {
        {
            e.stopPropagation();
            this.resetImageKey();
        }
    }
    function onChange5(AR, styleClass, enabledClass, disabledBorderClass, KVLayerCountMax, title, e) {
        AR.e(PARTS.STONE_SETUP_EDIT_NAME) && this.onChange('name', e.target.value);
    }
    function onBlur6(AR, styleClass, enabledClass, disabledBorderClass, KVLayerCountMax, title, e) {
        AR.e(PARTS.STONE_SETUP_EDIT_NAME) && this.updateNameTransientField(e.target.value);
    }
    function scopeTitle7(AR, styleClass, enabledClass, disabledBorderClass, KVLayerCountMax) {
        var title = 'Original Name: ' + this.props.stone.name;
        return React.createElement('div', { 'className': 'stone-description-frame' }, React.createElement('div', { 'className': 'stone-description-text-outline' }), React.createElement('input', {
            'className': 'stone-description-text',
            'placeholder': 'Enter Name',
            'value': this.state.name,
            'title': title,
            'readOnly': !AR.e(PARTS.STONE_SETUP_EDIT_NAME),
            'maxLength': '45',
            'onChange': onChange5.bind(this, AR, styleClass, enabledClass, disabledBorderClass, KVLayerCountMax, title),
            'onBlur': onBlur6.bind(this, AR, styleClass, enabledClass, disabledBorderClass, KVLayerCountMax, title)
        }));
    }
    function scopeARStyleClassEnabledClassDisabledBorderClassKVLayerCountMax8() {
        var AR = this.props.AR;
        var styleClass = 'stone-component';
        var enabledClass = `stone-${ this.state.enabled ? 'enabled' : 'disabled' }`;
        var disabledBorderClass = !this.state.enabled && AR.e(PARTS.STONE_SETUP_ENABLE) ? `${ enabledClass }-border` : '';
        var KVLayerCountMax = 72;
        return React.createElement('div', { 'className': 'stone-component-wrapper' }, React.createElement('div', {
            'className': 'stone-component ' + (!this.state.enabled ? `${ styleClass }-disabled` : ''),
            'data-stone-id': this.props.stone.id
        }, React.createElement('div', {
            'id': 'StatusFlag',
            'className': 'stone-enable-container ' + enabledClass + ' ' + disabledBorderClass
        }, React.createElement('div', {
            'className': disabledBorderClass + ' stone-enable-radio',
            'onClick': onClick1.bind(this, AR, styleClass, enabledClass, disabledBorderClass, KVLayerCountMax)
        }, this.state.enabled ? React.createElement('i', {
            'className': 'stone-enable-checkmark',
            'key': '918'
        }) : null, !this.state.enabled ? React.createElement('i', {
            'className': 'stone-disable-circle',
            'key': '991'
        }) : null), '\r\n      ', this.state.enabled ? 'Enabled' : 'Disabled', '\r\n    '), !this.isAssignedPricingProfile() || this.shouldShowPriceAnyway() ? React.createElement('div', {
            'className': 'stone-price-frame',
            'key': '1138'
        }, React.createElement('div', { 'className': 'stone-price-text-outline' }), React.createElement('input', {
            'className': 'stone-price-text',
            'placeholder': 'Enter Price',
            'value': this.state.price,
            'readOnly': !AR.e(PARTS.STONE_SETUP_EDIT_PRICE),
            'onChange': onChange2.bind(this, AR, styleClass, enabledClass, disabledBorderClass, KVLayerCountMax),
            'onBlur': onBlur3.bind(this, AR, styleClass, enabledClass, disabledBorderClass, KVLayerCountMax)
        })) : null, AR.isSiteAdmin() && !this.props.isInMaster ? React.createElement('div', {
            'className': 'stone-is-master',
            'key': '1723'
        }, React.createElement(CheckBox, {
            'checked': this.state.setAsMaster,
            'text': 'Set as Master',
            'onChecked': this.handleIsInMasterCheck.bind(this)
        })) : null, AR.isSiteAdmin() ? React.createElement('div', {
            'className': 'stone-delete-icon-circle',
            'onClick': this.props.deleteStone,
            'key': '1945'
        }) : null, AR.isSiteAdmin() || AR.isFabAdmin() && this.state.isOwner ? React.createElement('div', {
            'className': 'stone-edit-icon-circle',
            'onClick': this.props.editStone,
            'key': '2053'
        }) : null, React.createElement('div', {
            'className': 'stone-kv-icon-circle ' + (this.props.stone.kVLayerCount > 0 ? this.props.stone.kVLayerCount == KVLayerCountMax ? 'on' : this.props.stone.kVLayerCount > KVLayerCountMax ? 'extra' : 'partial' : 'off'),
            'title': this.props.stone.kVLayerCount == 0 ? 'Stone has no KV Layers' : this.props.stone.kVLayerCount > KVLayerCountMax ? 'More KV Layers than there should be' : this.props.stone.kVLayerCount < KVLayerCountMax ? 'Less KV Layers than there should be' : 'Just the right amount of KV Layers'
        }), React.createElement('div', {
            'className': 'stone-component-innerline',
            'style': { backgroundImage: 'url(\'' + this.state.image + '\')' },
            'onClick': this.onStoneClick.bind(this)
        }, this.isAssignedPricingProfile() ? React.createElement('div', {
            'className': 'assign-card__icon',
            'onClick': this.editAssignedPricingProfile,
            'style': {
                backgroundImage: 'url(' + this.getPricingProfileIcon() + ')',
                cursor: 'pointer',
                top: '10px',
                left: '2px',
                width: '70px',
                height: '70px',
                margin: '0'
            },
            'title': this.getPricingProfileName() + ' Pricing Profile',
            'key': '2862'
        }) : null, React.createElement('div', {
            'className': 'stone-component-upload',
            'style': { zIndex: '2' }
        }, this.state.showReset ? React.createElement('div', {
            'className': 'stone-component-clear',
            'onClick': onClick4.bind(this, AR, styleClass, enabledClass, disabledBorderClass, KVLayerCountMax),
            'key': '3290'
        }, 'Reset Stone Image') : null, React.createElement('input', {
            'type': 'file',
            'className': 'invisible',
            'onClick': e => {
                e.stopPropagation();
            },
            'onChange': this.handleFileSelect.bind(this),
            'ref': node => {
                this.fileUploadNode = node;
            }
        }))), scopeTitle7.apply(this, [
            AR,
            styleClass,
            enabledClass,
            disabledBorderClass,
            KVLayerCountMax
        ])));
    }
    return scopeARStyleClassEnabledClassDisabledBorderClassKVLayerCountMax8.apply(this, []);
}